<template>
  <v-container>
    <v-card>
      <v-card-title> Avaliações </v-card-title>
      <v-card-subtitle>#módulo</v-card-subtitle>

      <v-container class="w-75">
        <v-row class="mb-8">
          <CreateRating />
          <router-link
            class="mx-auto"
            to="/classItems"
            style="text-decoration: none; color: inherit"
          >
            <v-hover v-slot="{ isHovering, props }" open-delay="10">
              <v-card
                :elevation="isHovering ? 12 : 2"
                v-bind="props"
                class="pointer text-center"
                height="100px"
                width="140px"
              >
                <v-icon
                  class="mt-3"
                  size="x-large"
                  icon="mdi-format-list-bulleted-square"
                />
                <v-card-text class="pt-0"> Classificação de Itens </v-card-text>
              </v-card>
            </v-hover>
          </router-link>

          <router-link
            class="mx-auto"
            to="/items"
            style="text-decoration: none; color: inherit"
          >
            <v-hover v-slot="{ isHovering, props }" open-delay="10">
              <v-card
                :elevation="isHovering ? 12 : 2"
                v-bind="props"
                class="pointer mx-auto text-center"
                height="100px"
                width="140px"
              >
                <v-icon
                  class="mt-3"
                  size="x-large"
                  icon="mdi-help-box-multiple"
                />
                <v-card-text class="pt-0">
                  Itens de Avaliação
                </v-card-text></v-card
              >
            </v-hover>
          </router-link>

          <router-link
            class="mx-auto"
            to="/forms"
            style="text-decoration: none; color: inherit"
          >
            <v-hover v-slot="{ isHovering, props }" open-delay="10">
              <v-card
                :elevation="isHovering ? 12 : 2"
                v-bind="props"
                class="pointer mx-auto text-center"
                height="100px"
                width="140px"
              >
                <v-icon
                  class="mt-3"
                  size="x-large"
                  icon=" mdi-clipboard-list"
                />
                <v-card-text class="pt-2"> Formulários </v-card-text></v-card
              >
            </v-hover>
          </router-link>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import CreateRating from '@/components/dialogs/CreateRating.vue';
export default {
  components: {
    CreateRating,
  },
};
</script>
<style></style>
